import { type FC } from "react";
import * as styles from "./styles.css";

export type TelContentsProps = {
  telNumber: string;
  workCode: string;
};

export const TelContents: FC<TelContentsProps> = ({ telNumber, workCode }) => (
  <ul className={styles.telList}>
    <i className="icon-phone" />
    <li>
      TEL応募：
      <span className={styles.telNum}>{telNumber}</span>
    </li>
    <li className={styles.telWorkNum}>
      求人番号：<b>{workCode}</b>をお控えください
    </li>
  </ul>
);
